import React from "react";
import appleIcon from "../assets/images/apple-icon.svg";
import playIcon from "../assets/images/google-play-icon.svg";

import config from "../constants/config";

function StoreButton({ href, icon, label }) {
  return (
    <a
      className="button flex-center"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
      style={{ textDecoration: "none" }}
    >
      <img src={icon} alt="" className="button-store-icon" />
      {label}
    </a>
  );
}

function DownloadButton() {
  return (
    <div className="download-buttons">
      <StoreButton
        href={config.appleStoreLink}
        icon={appleIcon}
        label="Download on iOS"
      />
      <StoreButton
        href={config.playStoreLink}
        icon={playIcon}
        label="Download on Android"
      />
    </div>
  );
}

export default DownloadButton;
